<template>
    <div class="certificateBox">
        <div class="content" style="background: #fff;">
            <div style="display: flex;width: 100%;justify-content: space-between;">
                <Button type="primary" @click="dialogFormVisible = true">新建</Button>
                <el-cascader
                        size="small"
                        :options="workPermitList"
                        clearable
                        v-model="permitValue"
                        :props="replaceData"
                        @change="getData(1)"
                        placeholder="请选择证书类型"
                ></el-cascader>
                <el-select
                        v-model="contracValue"
                        clearable
                        placeholder="请选择承包商"
                        size="small"
                        @change="getData(1)"
                >
                    <el-option
                            v-for="item in contracList"
                            :key="item.id"
                            :label="item.contrName"
                            :value="item.id"
                    ></el-option>
                </el-select>
                <Input
                        search
                        enter-button
                        placeholder="请输入证书编号/证书名称/发证机关/所属单位"
                        v-model="fileNameOrTag"
                        @on-search="getData(1)"
                        style="width: 300px"
                />
            </div>
            <div style="margin-top: 20px;">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="certificateNo" label="证书编号">
                        <template slot-scope="scope">
                            <!-- <a :download="scope.row.fileName" v-bind:href="scope.row.fileUrl">{{scope.row.certificateNo}}</a> -->
                            <el-link
                                    style="color: #409EFF"
                                    @click="openDrawer(scope.row.id)"
                            >{{ scope.row.certificateNo }}
                            </el-link>
                        </template>
                    </el-table-column>
                    <el-table-column prop="certificateName" label="证书名称"></el-table-column>
                    <el-table-column prop="issuingAuthority" label="发证机关"></el-table-column>
                    <el-table-column label="所属单位">
                        <template slot-scope="scope">
                            <span v-if="scope.row.type === 0">本企业</span>
                            <span v-if="scope.row.type === 1">{{ scope.row.affiliatedCompanies }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ownerEmployeeName" label="拥有者"></el-table-column>
                    <el-table-column prop="authorizeProject" label="批准项目"></el-table-column>
                    <el-table-column prop="certificateTypeName" label="证书类别"></el-table-column>
                    <el-table-column prop="getCertificateTime" label="发证日期">
                        <template slot-scope="scope">
                            <span>{{ scope.row.getCertificateTime | filterTime }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="expireTime" label="到期时间">
                        <template slot-scope="scope">
                            <span>{{ scope.row.expireTime | filterTime }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="nextReviewTime" label="下次复审时间">
                        <template slot-scope="scope">
                            <span>{{ scope.row.nextReviewTime | filterTime }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="days" label="剩余时间">
                        <template slot-scope="scope">
                            <el-tag type="danger" v-if="scope.row.days">{{ scope.row.days }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="oper" label="操作">
                        <template slot-scope="scope">
                            <div slot="reference" class="name-wrapper">
                                <el-link type="primary" @click="handChange(scope.row)">编辑</el-link>
                                <span style="margin: 0 5px">|</span>
                                <el-link type="primary" @click="review(scope.row.id)"
                                         v-show="checkPerson(scope.row.alertOthersIds)">复审 |
                                </el-link>
                                <el-link type="danger" @click="handleDel(scope.row)">删除</el-link>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <Page
                        style="float: right;margin-top: 10px;"
                        :total="total"
                        :page-size="sizePage"
                        :current="curPage"
                        @on-change="getData"
                />
            </div>
        </div>

        <!-- 弹出框 -->
        <div class="formBox">
            <el-dialog title="证书" :visible.sync="dialogFormVisible" top="6vh" width="50%" @close="closeDialog">
                <div class="content">
                    <el-form
                            :model="ruleForm"
                            :rules="addRules"
                            ref="ruleForm"
                            label-width="140px"
                            class="demo-ruleForm"
                            style="width: 90%;"
                    >
                        <el-form-item label="" label-width="0">
                            <el-col :span="12">
                                <el-form-item label="选择单位" prop="contractorId">
                                    <el-select
                                            v-model="ruleForm.contractorId"
                                            placeholder="请选择单位"
                                            size="small"
                                            @change="chooseContrac11"
                                    >
                                        <el-option
                                                v-for="item in contracList"
                                                :key="item.id"
                                                :label="item.contrName"
                                                :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="拥有者" prop="ownerEmployeeId">
                                    <el-select v-model="ruleForm.ownerEmployeeId" filterable placeholder="请选择"
                                               size="small">
                                        <el-option v-for="item in userData" :key="item.id" :label="item.name"
                                                   :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="" label-width="0">
                            <el-col :span="12">
                                <el-form-item label="证书编号" prop="certificateNo">
                                    <el-input v-model="ruleForm.certificateNo" size="small"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="证书名称" prop="certificateName">
                                    <el-input v-model="ruleForm.certificateName" size="small"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="" label-width="0">
                            <el-col :span="12">
                                <el-form-item label="批准项目" prop="authorizeProject">
                                    <el-input v-model="ruleForm.authorizeProject" size="small"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="发证机关" prop="issuingAuthority">
                                    <el-input v-model="ruleForm.issuingAuthority" size="small"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="" label-width="0">
                            <el-col :span="12">
                                <el-form-item label="发证日期" prop="getCertificateTime">
                                    <el-date-picker
                                            v-model="ruleForm.getCertificateTime"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            type="date"
                                            size="small"
                                            placeholder="选择日期"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="到期日期" prop="expireTime">
                                    <el-date-picker
                                            v-model="ruleForm.expireTime"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            type="date"
                                            size="small"
                                            placeholder="选择日期"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <!-- <el-form-item label="复审时间" prop="jobs">
                          <el-date-picker v-model="ruleForm.reviewTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                            placeholder="选择日期"></el-date-picker>
                        </el-form-item>-->
                        <el-form-item label="" label-width="0">
                            <el-col :span="24">
                                <el-form-item label="下次复审时间" prop="nextReviewTime">
                                    <el-date-picker
                                            v-model="ruleForm.nextReviewTime"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            type="date"
                                            size="small"
                                            placeholder="选择日期"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="" label-width="0">
                            <el-col :span="24">
                                <el-form-item label="文件" prop="jobs">
                                    <el-upload
                                            class="upload-demo"
                                            drag
                                            action="/v1/certificate/uploadFile"
                                            :on-change="handleChange"
                                            :on-exceed="handleExceed"
                                            :limit="1"
                                            :file-list="fileList">
                                        <i class="el-icon-upload"></i>
                                        <div class="el-upload__text">
                                            将文件拖到此处，或
                                            <em>点击上传</em>
                                        </div>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="" label-width="0">
                            <el-col :span="12">
                                <el-form-item label="证书类别" prop="certificateTypeId">
                                    <!-- <el-input
                                      v-model="ruleForm.certificateType"
                                      placeholder="请输入证书类别"
                                      style="width:500px"
                                      size="small"
                                    ></el-input>-->
                                    <el-cascader
                                            size="small"
                                            :options="workPermitList"
                                            clearable
                                            v-model="ruleForm.certificateTypeId"
                                            :props="replaceData"
                                            placeholder="请选择证书类型"
                                    ></el-cascader>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="通知人" prop="alertOthersIds">
                                    <el-select
                                            v-model="ruleForm.alertOthersIds"
                                            clearable
                                            filterable
                                            multiple
                                            placeholder="请选择"
                                            size="small">
                                        <el-option
                                                v-for="item in userData2"
                                                :key="item.id"
                                                :label="item.nickname"
                                                :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                    </el-form>


                </div>
                <div slot="footer" class="dialog-footer" style="margin:auto">
                    <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
                    <el-button type="primary" @click="submitForm" size="small">确 定</el-button>
                </div>
            </el-dialog>
        </div>

        <!-- 复审的弹窗 -->
        <el-dialog title="复审" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
            <el-form label-width="110px" :model="formFH" :rules="rules" ref="formFH">
                <el-form-item label="复审内容" prop="reCheckContent">
                    <el-input v-model="formFH.reCheckContent" type="textarea" :rows="3"
                              placeholder="请输入复审内容"></el-input>
                </el-form-item>
                <el-form-item label="下次复审时间" prop="reCheckTime">
                    <el-date-picker
                            v-model="formFH.reCheckTime"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间"
                    ></el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitDia">确 定</el-button>
      </span>
        </el-dialog>
        <!-- 详情的抽屉 -->
        <el-drawer :visible.sync="drawer" :show-close="false" direction="rtl" size="70%">
            <div slot="title" class="drawerTitle">
                <p>证书编号：{{ drawerObj.certificateNo }}
                    <i class="el-icon-circle-close" @click="drawer = false"></i>
                </p>
                <div class="tWord">
                    <div><p>证书名称</p><span>{{ drawerObj.certificateName }}</span></div>
                    <div><p>拥有者</p><span>{{ drawerObj.ownerEmployeeName }}</span></div>
                    <div><p>所属单位</p><span>{{ drawerObj.affiliatedCompanies }}</span></div>
                    <div><p>证书类别</p><span>{{ drawerObj.certificateTypeName }}</span></div>
                    <div><p>创建时间</p><span>{{ drawerObj.gmtCreate }}</span></div>
                </div>
            </div>
            <div class="drawerBody">
                <el-tabs v-model="activeName">
                    <el-tab-pane label="详情" name="a"></el-tab-pane>
                </el-tabs>
                <div class="bodyInner">
                    <div class="innerDetail">
                        <div>发证机关: {{ drawerObj.issuingAuthority }}</div>
                    </div>
                    <div class="innerDetail">
                        <div>批准项目: {{ drawerObj.authorizeProject }}</div>
                    </div>
                    <div class="innerDetail">
                        <div>发证日期: {{ drawerObj.getCertificateTime }}</div>
                    </div>
                    <div class="innerDetail">
                        <div>到期时间: {{ drawerObj.expireTime }}</div>
                    </div>
                    <div class="innerDetail">
                        <div>下次复审时间: {{ drawerObj.nextReviewTime }}</div>
                    </div>
                    <div class="innerDetail">
                        <div>通知人: {{ drawerObj.alertOthersIds }}</div>
                    </div>
                    <div class="innerDetail" v-show="drawerObj.fileName">
                        <div>文件名:
                            <el-link type="primary" @click="download(drawerObj.fileUrl,drawerObj.fileName)">
                                {{ drawerObj.fileName }}
                            </el-link>
                        </div>
                    </div>
                    <el-table :data="drawerTable" border max-height="500px" style="width: 100%;margin-top: 15px">
                        <el-table-column
                                type="index"
                                :index="(index) => {return index + 1}"
                                width="80"
                                label="序号"
                        ></el-table-column>
                        <el-table-column prop="reCheckContent" show-overflow-tooltip label="复审内容"></el-table-column>
                        <el-table-column prop="gmtCreate" label="复审时间"></el-table-column>
                        <el-table-column prop="reCheckUserName" label="复审人"></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="{row}">
                                <span style="cursor: pointer;color: red" @click="deteleDetail(row.id)">删除</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
    import {downLoadDocument} from "@/api/downLoad";
    import {
        getApplicantSelect,
        getCertificateType,
        certificateFH,
        certificateDetail,
        deteleReview,
        getAlluser, pubEngineeringEdit, pubEngineeringAdd, getStaffList
    } from "@/api/processManager";

    export default {
        data() {
            return {
                total: 10,
                sizePage: 10,
                currentPage: 1,
                tableData: [],
                fileNameOrTag: "",
                curPage: 1,
                workPermitList: [], // 级联选择器的数组
                permitValue: [], // 选择的证书类型
                replaceData: {
                    value: "id",
                    label: "name",
                    children: "childList"
                },
                contracList: [], //承包商数组
                contracValue: "", // 承包商id
                dialogVisible: false, // 复审弹窗的状态
                formFH: {
                    // 复审的表单
                    reCheckContent: "",
                    reCheckTime: ""
                },
                rules: {
                    reCheckContent: [{required: true, message: "请输入复审内容"}],
                    reCheckTime: [{required: true, message: "请选择下次复审时间"}]
                },
                certificateId: "", // 证书的id
                // 详情的一些数据
                drawer: false,
                activeName: 'a',
                drawerTable: [], //详情表格
                drawerObj: {}, // 详情的所有数据
                // 人员列表
                userList: [],
                dialogFormVisible: false,
                advice: [],
                userData2: [],
                isAdd: true,
                isEdit: false,
                ruleForm: {
                    certificateName: "",
                    contractorId: "", //选择的承包商
                    alertOthersIds: [], // 选择的通知人
                    certificateTypeId: [] // 选择的证书类型
                },

                addRules: {
                    contractorId: [{required: true, message: "请选择单位", trigger: "change"}],
                    ownerEmployeeId: [{required: true, message: "请选择持有人", trigger: "change"}],
                    certificateNo: [{required: true, message: "请输入证书编号"}],
                    issuingAuthority: [{required: true, message: "请输入发证机关"}],
                    getCertificateTime: [{required: true, message: "发证日期"}],
                    expireTime: [{required: true, message: "到期日期"}],
                    nextReviewTime: [{required: true, message: "下次复审时间"}],
                    alertOthersIds: [{required: true, message: "请选择通知人", trigger: "change"}],
                    certificateTypeId: [{required: true, message: "请选择作业证类型", trigger: "change"}],
                    certificateName: [{required: true, message: "请输入证书名称", trigger: "change"}]
                },
                fileList: [],
                getObj: {},
                userData: []
            };
        },
        filters: {
            filterTime(time) {
                return time.split(" ")[0];
            }
        },
        mounted: async function () {
            this.getWorkPermit(); // 作业证类型数据
            this.getCBSlist(); // 承包商列表数据
            this.getUser(); //获取用户列表
            if (this.$route.query.certificateId) {
                await this.getData(1)
                this.openDrawer(this.$route.query.certificateId)
            } else if (this.$route.query.certificateNo) {
                this.fileNameOrTag = this.$route.query.certificateNo
                await this.getData(1)
                if (this.tableData.length > 0) {
                    this.openDrawer(this.tableData[0].id)
                }
            } else {
                this.getData(1); // 表格数据
            }
            this.componentsMoudel.httpRequest.getRequestHander(this.componentsMoudel.getData("urls").getAllUser).openLoad().startGet().then(res => {
                this.userData2 = res.body.data;
            });
        },
        created() {
        },
        methods: {
            // 提交保存数据
            submitForm() {
                this.$refs['ruleForm'].validate(valid => {
                    if (valid) {
                        let url = "";
                        if (this.isAdd) {
                            url = this.componentsMoudel.getData("urls").saveCertificate;
                        } else if (this.isEdit) {
                            url = "/certificate/update";
                        }
                        if (this.fileList.length > 0) {
                            this.ruleForm.fileName = this.fileList[0].name;
                            this.ruleForm.fileUrl = this.fileList[0].response.data;
                        }
                        // this.ruleForm.alertOthersIds = JSON.stringify(this.advice);
                        let obj = {...this.ruleForm};
                        obj.alertOthersIds = JSON.stringify(this.ruleForm.alertOthersIds);
                        obj.certificateTypeId = this.ruleForm.certificateTypeId[1];
                        this.componentsMoudel.httpRequest
                            .getRequestHander(url)
                            .openLoad()
                            .startPost(obj)
                            .then(res => {
                                this.$message({
                                    showClose: true,
                                    message: "操作成功",
                                    type: "success"
                                });
                                this.dialogFormVisible = false;
                                this.getData(1); // 表格数据
                            });
                    } else {
                        return false;
                    }
                });
            },
            handleChange(file, fileList) {
                this.fileList = fileList.slice(-3);
            },
            // 限制文件上传数量
            handleExceed(files, fileList) {
                this.$message.warning(
                    `当前限制选择 1 个文件，本次选择了 ${
                        files.length
                    } 个文件，共选择了 ${files.length + fileList.length} 个文件`
                );
            },
            // 关闭弹出框的事件
            closeDialog() {
                this.$refs['ruleForm'].resetFields();
                this.isEdit = false;
            },

            chooseContrac11(id) {
                this.$set(this.ruleForm, "ownerEmployeeId", "");
                // 选择承包商后，获取下面对应的人员
                this.userData = [];
                getStaffList({contractorId: id}).then(res => {
                    let arr = res.body.data;
                    if (arr.length && arr.length > 0) {
                        this.userData = arr;
                    } else {
                        this.$message.error(
                            "该承包商还没有人员，请先去添加人员或者选择其它承包商"
                        );
                    }
                });
            },


            handleSizeChange(val) {
                this.sizePage = val;
                this.getEmployeeList(this.currentPage, this.sizePage);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getEmployeeList(this.currentPage, this.sizePage);
            },
            // 下载文件
            download(url, name) {
                downLoadDocument(url, name);
            },
            async getData(page) {
                if (page) {
                    this.curPage = page;
                }
                let param = {};
                param.limit = this.sizePage;
                param.curPage = page;
                param.name = this.fileNameOrTag;
                if (this.permitValue.length > 0) {
                    param.certificateTypeId = this.permitValue[1];
                }
                if (this.contracValue !== "") {
                    param.contractorId = this.contracValue;
                }
                await this.componentsMoudel.httpRequest
                    .getRequestHander(this.componentsMoudel.getData("urls").getCertificate)
                    .openLoad()
                    .startPost(param)
                    .then(res => {
                        this.tableData = res.body.data;
                        for (var i = 0; i < this.tableData.length; i++) {
                            var planTime = this.tableData[i].nextReviewTime;
                            if (planTime) {
                                let checkTime = planTime.split(" ")[0];
                                let days = this.DateDiff(checkTime);
                                if (!days) {
                                    days = "剩余0天";
                                }
                                this.tableData[i].days = days;
                            }
                        }
                        this.currentPage = res.body.page;
                        this.total = res.body.cum;
                        this.pageTotal = res.body.pageTotal;
                    });
            },
            getNowDate() {
                let date = new Date();
                let y = date.getFullYear();
                let m = date.getMonth() + 1;
                let d = date.getDate();
                return y + "-" + m + "-" + d;
            },
            DateDiff(sDate1) {
                //sDate1和 sDate2 是2002-12-18格式
                let sDate2 = this.getNowDate();
                var aDate, oDate1, oDate2, iDays;
                aDate = sDate1.split("-");
                oDate1 = new Date(aDate[1] + "-" + aDate[2] + "-" + aDate[0]); //转换为12-18-2002格式
                aDate = sDate2.split("-");
                oDate2 = new Date(aDate[1] + "-" + aDate[2] + "-" + aDate[0]);
                iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24); //把相差的毫秒数转换为天数
                let result = this.tab(sDate1, sDate2);
                if (result == 1) {
                    return "剩余" + iDays + "天";
                } else {
                    return "逾期" + iDays + "天";
                }
            },
            tab(date1, date2) {
                var oDate1 = new Date(date1);
                var oDate2 = new Date(date2);
                if (oDate1.getTime() > oDate2.getTime()) {
                    return 1;
                } else {
                    return 0;
                }
            },
            handleAdd() {
                this.$router.push({
                    path: "addCerInfo"
                });
            },
            handChange(row) {
                let obj = {...row};
                if (obj.alertOthersIds) {
                    obj.alertOthersIds = JSON.parse(obj.alertOthersIds);
                }
                this.chooseContrac11(0);
                this.dialogFormVisible = true
                this.isEdit = true
                this.ruleForm = row;
                this.$set(this.ruleForm, 'alertOthersIds', obj.alertOthersIds);
            },
            handleDel(row) {
                console.log(row);
                this.$confirm(
                    `删除 ${row.ownerEmployeeName}-《${row.certificateName}》, 是否继续?`,
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }
                )
                    .then(() => {
                        this.componentsMoudel.httpRequest
                            .getRequestHander("/certificate/delete/" + row.id)
                            .openLoad()
                            .startDel({})
                            .then(res => {
                                if (this.tableData.length <= 1 && this.curPage > 1) {
                                    this.curPage -= 1;
                                }
                                this.$message({
                                    showClose: true,
                                    message: "删除成功",
                                    type: "success"
                                });
                                this.getData(this.curPage);
                            });
                    })
                    .catch(() => {
                        return;
                    });
            },
            // 获取作业证类型
            getWorkPermit() {
                getCertificateType({type: 3}).then(res => {
                    this.workPermitList = res.body.data;
                });
            },
            // 获取承包商列表
            getCBSlist() {
                getApplicantSelect().then(res => {
                    let arr = res.body.data;
                    arr.unshift({id: 0, contrName: "本厂商"});
                    this.contracList = arr;
                });
            },
            // 复审功能
            review(id) {
                this.dialogVisible = true;
                this.certificateId = id;
            },
            // 复审弹窗关闭（点图层）
            handleClose() {
                this.$refs["formFH"].resetFields();
                this.dialogVisible = false;
            },
            // 提交复审
            submitDia() {
                this.$refs["formFH"].validate(valid => {
                    if (valid) {
                        certificateFH({
                            certificateId: this.certificateId,
                            reCheckContent: this.formFH.reCheckContent,
                            reCheckTime: this.formFH.reCheckTime
                        }).then(res => {
                            this.handleClose();
                            this.getData();
                        });
                    } else {
                        return false;
                    }
                });
            },
            // 点击编号，打开详情抽屉
            openDrawer(id) {
                this.certificateId = id
                certificateDetail(id).then(res => {
                    let arr = JSON.parse(res.body.data.alertOthersIds)
                    console.log(arr)
                    let newArr = []
                    for (let i in arr) {
                        for (let j in this.userList) {
                            if (arr[i] == this.userList[j].id) {
                                newArr.push(this.userList[j].nickname)
                            }
                        }
                    }
                    this.drawerObj = {...res.body.data}
                    this.$set(this.drawerObj, 'alertOthersIds', newArr.join(','))
                    this.drawerTable = res.body.data.reChecks
                    this.drawer = true
                })
            },
            // 删除复审记录
            deteleDetail(id) {
                deteleReview(id).then(res => {
                    this.$message.success("删除成功")
                    this.openDrawer(this.certificateId)
                })
            },
            // 调取用户的列表，用于详情里面显示通知人和复审人，和审核的权限判断
            getUser() {
                getAlluser().then(res => {
                    this.userList = res.body.data
                })
            },
            // 判断是否为审核人
            checkPerson(val) {
                let arr = val;
                let userId = localStorage.getItem('userId')
                let status = false
                for (let i in arr) {
                    if (arr[i] == userId) {
                        status = true
                        break
                    }
                }
                ;
                return status
            }
        }
    };
</script>

<style scoped>
    .addBtn {
        width: 100px;
        position: absolute;
        top: 10px;
        right: 10px;
    }

    /* <!--         抽屉样式           --> */
    .drawerTitle {
        box-shadow: 0px 5px 5px -5px black;
        height: 120px;
        padding: 0 15px
    }

    .drawerTitle > p {
        color: #000000;
        font-size: 18px;
        line-height: 55px;
    }

    .drawerTitle > p > i {
        font-size: 30px;
        float: right;
        margin: 15px 10px 0 0;
    }

    .drawerTitle > p > i:hover {
        color: #409EFF
    }

    .el-drawer__header {
        padding: 0 15px;
        margin-bottom: 0
    }

    /* 解决tab切换会有蓝色边框的问题 */
    .certificateBox /deep/ .el-tabs__item:focus.is-active.is-focus:not(:active) {
        box-shadow: none;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
    }

    /*  */

    .tWord {
        display: flex
    }

    .tWord div > p {
        font-size: 15px;
        line-height: 25px;
    }

    .tWord div > span {
        color: #000000
    }

    .tWord div {
        width: 220px
    }

    .drawerBody {
        width: 100%;
        height: calc(100vh - 160px);
        background: rgb(247, 247, 247);
        overflow: hidden;
        padding: 10px 20px 20px;
    }

    .bodyInner {
        background: white;
        height: calc(100% - 60px);
        width: 100%;
        border: 1px solid #eaeaea;
        overflow: scroll;
    }

    .innerDetail {
        line-height: 35px;
        font-size: 16px;
        padding-left: 10px;
        display: inline-block;
        width: 50%;
        color: #72767b;
    }
</style>
